import { render, staticRenderFns } from "./AddCrossReference.vue?vue&type=template&id=a53636a2"
import script from "./AddCrossReference.ts?vue&type=script&lang=ts&external"
export * from "./AddCrossReference.ts?vue&type=script&lang=ts&external"
import style0 from "./AddCrossReference.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports